import { PureComponent } from 'react';
import { connect } from 'react-redux';

import ProductDeliveryOptions from './ProductDeliveryOptions.component';

export const mapStateToProps = (state) => ({
    threshold: state.ConfigReducer.freeShipping.threshold,
    grand_total: state.CartReducer.cartTotals.grand_total,
    default_display_currency_code: state.ConfigReducer.default_display_currency_code,
    code: state.ConfigReducer.code
});

export class ProductDeliveryOptionsContainer extends PureComponent {
    containerProps = () => {
        const {
            threshold,
            grand_total,
            default_display_currency_code,
            delivery_dates,
            stock_status,
            salable_quantity_oos,
            attributes,
            code
        } = this.props;

        return {
            threshold,
            grand_total,
            default_display_currency_code,
            delivery_dates,
            stock_status,
            salable_quantity_oos,
            attributes,
            code
        };
    };

    render() {
        return <ProductDeliveryOptions { ...this.containerProps() } />
    }
}

export default connect(mapStateToProps)(ProductDeliveryOptionsContainer);
